// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";

// 使用 Vue.use() 注册插件
Vue.use(VueRouter);

// 引入页面组件（确保这些文件存在）
import Index from "../views/index.vue";
import Achievements from "../views/Achievements.vue";
import Patent from "../views/Patent.vue";
import Cases from "../views/Cases.vue";
import Contact from "../views/Contact.vue";
import Development from "../views/DevelopmentPermit.vue";
import AchievementLibrary from "../views/AchievementLibrary.vue";
import OpenPatent from "../views/OpenPatent.vue";
import PAF_sale from "../views/PAF_sale.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import MemberCenter from "../views/MemberCenter.vue";
import TechnicalDemand from "../views/TechnicalDemand.vue";
import CasesDetails from "../views/CasesDetails.vue";
import AchievementDetails from "../views/AchievementDetails.vue";
import Brand from "../views/Brand.vue";
import PaidLicense from "../views/PaidLicense.vue";
import TrademarkSale from "../views/TrademarkSale.vue";
import TrademarkPurchase from "../views/TrademarkPurchase.vue";
import OpenDetails from "../views/OpenDetails.vue";
import Clause from "../views/Clause.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";

const routes = [
  {
    path: "/",
    component: Index,
    meta: {
      customHeader: true, // 添加自定义标记
      customFooter: true, // 添加自定义标记
    },
  },
  { path: "/achievements", component: Achievements },
  { path: "/patent", component: Patent },
  { path: "/cases", component: Cases },
  { path: "/contact", component: Contact },
  { path: "/development", component: Development },
  { path: "/achievementLibrary", component: AchievementLibrary },
  { path: "/openPatent", component: OpenPatent },
  { path: "/pAF_sale", component: PAF_sale },
  { path: "/technicalDemand", component: TechnicalDemand },
  { path: "/casesDetails", component: CasesDetails },
  { path: "/achievementDetails", component: AchievementDetails },
  { path: "/brand", component: Brand },
  { path: "/paidLicense", component: PaidLicense },
  { path: "/trademarkSale", component: TrademarkSale },
  { path: "/trademarkPurchase", component: TrademarkPurchase },
  { path: "/openDetails", component: OpenDetails },
  { path: "/clause", component: Clause },
  { path: "/privacyPolicy", component: PrivacyPolicy },
  {
    path: "/memberCenter",
    component: MemberCenter,
    name: "memberCenter",
    children: [
      { path: "", redirect: "home" }, // 默认跳转首页
      {
        // 会员中心
        path: "home",
        component: () => import("@/components/MemberCenter/Home.vue"),
      },
      {
        // 发布专利
        path: "publish-patent",
        component: () => import("@/components/MemberCenter/PublishPatent.vue"),
      },
      {
        // 发布商标
        path: "publish-trademark",
        component: () =>
          import("@/components/MemberCenter/PublishTrademark.vue"),
      },
      {
        // 发布科技成果
        path: "publish-achievement",
        component: () =>
          import("@/components/MemberCenter/PublishAchievement.vue"),
      },
      {
        // 技术求购发布
        path: "publish-tech-demand",
        component: () =>
          import("@/components/MemberCenter/PublishTechDemand.vue"),
      },
      {
        // 专利需求发布
        path: "publish-patent-demand",
        component: () =>
          import("@/components/MemberCenter/PublishPatentDemand.vue"),
      },
      {
        // 商标需求发布
        path: "publish-trademark-demand",
        component: () =>
          import("@/components/MemberCenter/PublishTrademarkDemand.vue"),
      },
      {
        // 我的发布
        path: "my-publications",
        component: () => import("@/components/MemberCenter/MyPublications.vue"),
      },
    ],
  },
  {
    path: "/login",
    component: Login,
    meta: {
      customHeader: true, // 添加自定义标记
      customFooter: true, // 添加自定义标记
    },
  },
  {
    path: "/register",
    component: Register,
    meta: {
      customHeader: true, // 添加自定义标记
      customFooter: true, // 添加自定义标记
    },
  },
];

// 创建 router 实例
const router = new VueRouter({
  mode: "history", // 或 'hash'
  routes, // 缩写形式，等价于 routes: routes
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 返回保存的位置（浏览器前进/后退时）
    } else if (to.hash) {
      return {
        selector: to.hash, // 处理锚点链接
      };
    } else {
      return { x: 0, y: 0 }; // 默认滚动到顶部
    }
  },
});

export default router;
